import { render, staticRenderFns } from "./Renovacion.vue?vue&type=template&id=54ac1432"
import script from "./Renovacion.vue?vue&type=script&lang=js"
export * from "./Renovacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ac1432')) {
      api.createRecord('54ac1432', component.options)
    } else {
      api.reload('54ac1432', component.options)
    }
    module.hot.accept("./Renovacion.vue?vue&type=template&id=54ac1432", function () {
      api.rerender('54ac1432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/Renovacion.vue"
export default component.exports